/**
 * Typdefinitioner för DataReplay
 * Återläsning av historiska GPS-data
 */

export interface StepLogEntry {
  timestamp: string;
  step: string;
  status: 'running' | 'completed' | 'failed';
  duration?: number;
  details?: string;
  error?: string;
}

export interface ReplayStatus {
  id: string;
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
  request: {
    imei?: string;
    organizationId?: string;
    fromDate: string;
    toDate: string;
  };
  progress: {
    totalFiles: number;
    processedFiles: number;
    deletedTrips: number;
    deletedChunks: number;
    queuedMessages: number;
    tripsCreated?: number;
  };
  stepLog?: StepLogEntry[];
  startedAt?: string;
  completedAt?: string;
  error?: string;
}

export interface AvailableDate {
  date: string;
  fileCount: number;
  totalSize: number;
}

export interface VehicleOption {
  imei: string;
  regNumber: string | null;
  /** devices.organization_id (för filtrering mot vald org + underorg) */
  organizationId?: string;
}

export interface DataStatusResult {
  mongo: Record<string, number>;
  maria: Record<string, number>;
  redis: { dedupKeys: number; tripStateKeys: number; activeTripsSet: number };
  allCleared: boolean;
}

// Helpers
export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export type JobStatus = 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
